<template>
  <div class="c-app flex-row align-items-center mt-4">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Register</h1>
                <p class="text-muted">アカウントを作成</p>
                <CInput
                  class="account"
                  v-bind:class="{err: errs.name }"
                  v-model="user.name"
                  placeholder="Username"
                  autocomplete="username">
                </CInput>
                <p class="ml40" v-if="errs.name">{{errTexts.name}}</p>
                <CInput
                  class="email"
                  v-bind:class="{err: errs.email }"
                  v-model="user.email"
                  placeholder="Email"
                  autocomplete="email">
                </CInput>
                <p class="ml40" v-if="errs.email">{{errTexts.email}}</p>
                <CInput
                  class="tel"
                  v-bind:class="{err: errs.tel }"
                  v-model="user.tel"
                  placeholder="Tel">
                </CInput>
                <p class="ml40" v-if="errs.tel">{{errTexts.tel}}</p>
                <CInput
                  class="password"
                  v-bind:class="{err: errs.password }"
                  v-model="user.password"
                  placeholder="Password"
                  type="password"
                  autocomplete="new-password">
                </CInput>
                <p class="ml40" v-if="errs.password">{{errTexts.password}}</p>
                <CInput
                  class="password mb-4"
                  v-bind:class="{err: errs.password_repeat }"
                  v-model="user.password_repeat"
                  placeholder="Repeat password"
                  type="password"
                  autocomplete="new-password">
                </CInput>
                <p class="ml40" v-if="errs.password_repeat">{{errTexts.password_repeat}}</p>
                <CRow>
                  <CCol col="12" class="text-center">
                    <CButton color="success" class="px-4" @click="createAccount()">会員登録</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { freeSet } from '@coreui/icons'
export default {
  name: 'Register',
  freeSet,
  data () {
    return {
      user:{
        name: "",
        email: "",
        tel: "",
        password: "",
        password_repeat: ""
      },
      errs:{
        name: false,
        email: false,
        tel: false,
        password: false,
        password_repeat: false,
      },
      errTexts:{
        name: "",
        email: "",
        tel: "",
        password: "",
        password_repeat: ""
      }
    }
  },
  mounted: function () {
  },
  methods: {
    createAccount () {
      Object.keys(this.user).forEach(key => {
        this.errs[key] = false;
        this.errTexts[key] = "";
      });
      let nonData = false;
      Object.keys(this.user).forEach(key => {
        if(this.user[key] === ""){
          this.errs[key] = true;
          this.errTexts[key] = "値を入力してください";
          nonData = true;
        }
      });
      if(nonData) return false;

      const REG_EMAIL = /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
      if(!REG_EMAIL.test(this.user.email)){
        this.errs.email = true;
        this.errTexts.email = "メールアドレスを正しく入力してください";
      }
      if(this.user.password !== this.user.password_repeat){
        this.errs.password_repeat = true;
        this.errTexts.password_repeat = "パスワードが一致していません";
      }
      this.user.tel = this.user.tel.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
      const REG_TEL = /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/;
      if(!REG_TEL.test(this.user.tel)){
        this.errs.tel = true;
        this.errTexts.tel = "電話番号は数字のみで入力ください";
      }
      
      Object.keys(this.user).forEach(key => {
        if(this.errs[key]){
          nonData = true;
        }
      });
      if(nonData) return false;

      let api = new ApiService();
      api.postUser(this.user)
        .then((response) => {
          this.$swal('送信完了', "ご登録頂いたメールに確認メールを送信致しました、ご確認をお願い致します。", 'success')
            .then(() => {
              this.$router.push({path: "/app/color/login"});
            });
        })
        .catch((error) => {
          if(error.status === 409){
            this.errs.email = true;
            this.errTexts.email = "既に登録されているメールアドレスです";
          }
          if(error.status === 500){
            this.$swal('エラー', "登録が失敗しました、解決しない場合はサポートチームへお問い合わせください。", 'error');
          }
        });
    }
  }
}
</script>
